// extracted by mini-css-extract-plugin
export var brand = "_65-9";
export var compact = "_65-6";
export var extraSmall = "_65-7";
export var icon = "_65-0";
export var large = "_65-4";
export var light = "_65-1";
export var medium = "_65-5";
export var outline = "_65-b";
export var primaryDark = "_65-a";
export var primaryLight = "_65-8";
export var primaryModern = "_65-c";
export var success = "_65-2";
export var successSolid = "_65-3";